import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import lgbtWhiteLogo from '../assets/lgbt_white.png';

const Footer = () => {
  
  return (
    <footer className="footer lgbt-footer">
      <div className="footer-container">
        {/* Logo and Address Section */}
        <div className="footer-section footer-address">
          <div className="lgbt-footer-logo">
            <img 
              src={lgbtWhiteLogo} 
              alt="LGBT National Help Center" 
              className="footer-logo-image"
            />
            <span className="footer-logo-text">lgbt national help center</span>
          </div>
          <div className="address-info">
            <p><strong>2261 Market Street, #296</strong></p>
            <p><strong>San Francisco, CA 94114</strong></p>
          </div>
          {/* Social Media Icons */}
          <div className="footer-social-icons">
            <a href="https://www.instagram.com/lgbt_national_hotline/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z"/>
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/lgbt-national-help-center/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a href="https://x.com/LGBTNatlHelpCtr" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://www.youtube.com/user/glbtnhc" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/LGBTNationalHelpCenter" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Middle Links Section */}
        <div className="footer-section footer-links">
          <ul>
            <li><Link to="/about">About Us</Link></li>
            {/* <li><Link to="/map-resources">Resource Map</Link></li> */}
            <li><Link to="/contact">Contact</Link></li>
            <li><a href="https://givebutter.com/lgbthotline" target="_blank" rel="noopener noreferrer">Donate</a></li>
          </ul>
        </div>

        {/* Right Links Section */}
        <div className="footer-section footer-links">
          <ul>
            <li><a href="https://lgbthotline.org/" target="_blank" rel="noopener noreferrer">LGBT National Help Center</a></li>
            <li><a href="https://lgbtcomingout.org/" target="_blank" rel="noopener noreferrer">LGBT National Coming Out Support Hotline</a></li>
            <li><a href="https://www.lgbtnearme.org/" target="_blank" rel="noopener noreferrer">LGBT Near Me</a></li>
          </ul>
        </div>
      </div>

      {/* <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p>&copy; {currentYear} LGBT National Help Center. All rights reserved.</p>
          <div className="footer-legal-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/accessibility">Accessibility</Link>
          </div>
        </div>
      </div> */}
    </footer>
  );
};

export default Footer;